import React, { useState } from "react";
import AddNews from "components/news/AddNews";
import OpcNews from "components/news/OpcNews";
import CustomModal from "common/CustomModal";
import { useModalGac } from "hooks/useModalGac";
import "./DashboardCreateNews.css";

const DashboardCreateNews = () => {
  const [isOpenModal, openModal, closeModal] = useModalGac(false);
  const [search, setSearch] = useState("");

  return (
    <section className="container-page">
      <div className="news-header">
        <h1 className="text-title">Listado de noticias</h1>

        <div className="news-header-actions">
          <div className="news-search">
            <input
              type="text"
              placeholder="Buscar noticia..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <button className="categoryTicket" onClick={() => openModal()}>
            Crear Noticia / Noticia interna
          </button>
        </div>
      </div>

      <OpcNews search={search} />

      <CustomModal isOpen={isOpenModal} closeModal={closeModal}>
        <AddNews />
      </CustomModal>
    </section>
  );
};

export default DashboardCreateNews;
